import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import close_modal from "../../../assets/ic_close_wh.svg";
import newFacilitatorListSample from "../../../assets/newFacilitatorListSample.csv";

export default function FacilitatorReassignmentModal(props)
{
    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.toggleModal}
            ariaHideApp={false}
        >
          <ModalContent className="general-modal">
            <div className="modal-header">
                <span className="modal-title">Reassign Facilitator</span>
                <img
                    alt="close"
                    id="Close"
                    src={close_modal}
                    className="close modal-close"
                    onClick={props.toggleModal}
                />
            </div>
            
            <div className={`modal-body spled-container notes-trail-content custom-scrollbar`}>
                <div className="row conv-mt10 conv-ml0">                    
                    <div className="col-12 conv-pl10 conv-mt20">
                        <input className="form-control-custom" ref={props.FileInputref} type="file" onChange={props.onAssignFacilitatorUpload}/>
                    </div>
                    <div className="col-12 conv-mt5">
                        <span className="outbound-hint">Download Sample File {" "}</span>  
                        <a 
                            className="outbound-url-link"
                            href={newFacilitatorListSample} download="newFacilitatorListSample.csv"
                        >
                            Here
                        </a>
                    </div>  
                   
                </div>   
                <div className="row conv-mt10">
                    <div className="col-12 modal-bottom-action conv-mt25">
                        <button 
                            type="button" 
                            className={`lpm-con-btn-filled conv-pl25 conv-pr25 conv-float-right`}
                            onClick={props.uploadAssignFacilitatorFile}>
                            Upload 
                        </button>
                        <button 
                            type="button" 
                            className={`outbound-con-btn-bordered conv-mr25 conv-float-right`}
                            onClick={props.toggleModal}>
                            Cancel 
                        </button>
                    </div>
                </div>             
            </div>
          </ModalContent>
        </Modal>
      );
}